import * as React from 'react';
import { Space } from '@sravni/react-design-system';
import { appStores } from '../../../constants/appStores.js';
import { AppStore } from './AppStore.js';

const AppsList = (props) => {
    const { refs } = props;
    return (React.createElement(Space, { direction: 'vertical' },
        React.createElement(Space, { size: 4 },
            React.createElement(AppStore, { ref: refs.ruStore, store: appStores.ruStore, useIcon: true }),
            React.createElement(AppStore, { ref: refs.googlePlay, store: appStores.googlePlay, useIcon: true })),
        React.createElement(Space, { size: 4 },
            React.createElement(AppStore, { ref: refs.huaweiAppGallery, store: appStores.huaweiAppGallery, useIcon: true }),
            React.createElement(AppStore, { ref: refs.appStore, store: appStores.appStore, useIcon: true }))));
};

export { AppsList };
//# sourceMappingURL=AppsList.js.map
